var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIcArrowactive(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 14,
    height: 40
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#FEFCF0",
    fillRule: "evenodd",
    stroke: "#E7E7E7",
    strokeLinecap: "square",
    d: "M1 0l12 20L1 40"
  })));
}
export default SvgIcArrowactive;